import React from "react";
import { connect } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { Form, RootState } from "../../../../../../models";
import { FieldSet, Input } from "../../../../forms";
import { VALIDATION_FIELD } from "../../../../rapidform/formValidation";
import { RapidForm } from "../../../../rapidform/index";
import { getEmailFormById } from "../../../state/selectors";
import TEXT from "../../../text-consts";
import "./EmailForm.less";

interface StateProps {
    onboardingEmailForm: Form;
}

interface PersonalDetailsFormProps extends StateProps {
    onSubmitDetails: () => void;
}

const PersonalDetailsForm: React.FC<PersonalDetailsFormProps> = ({ onboardingEmailForm, onSubmitDetails }) => (
    <div className="onboarding-email-form">
        <RapidForm
            id={FORM_ID.ONBOARDING_EMAIL}
            action={"#"}
            errors={onboardingEmailForm.errors}
            values={onboardingEmailForm.values}
            visible={onboardingEmailForm.visible}
            started={onboardingEmailForm.started}
            onSubmit={onSubmitDetails}
        >
            <FieldSet name="details">
                <Input
                    type="email"
                    name={VALIDATION_FIELD.PRODUCT_USER_EMAIL}
                    label={TEXT.ONBOARDING_B2B.CONTACT_INFORMATION.EMAIL}
                    disabled={false}
                    data-di-mask
                />
            </FieldSet>
        </RapidForm>
        <p>{TEXT.ONBOARDING_B2B.CONTACT_INFORMATION.DISCLAIMER}</p>
    </div>
);

const mapStateToProps = (state: RootState): StateProps => ({
    onboardingEmailForm: getEmailFormById(state, "onboardingEmailForm"),
});

export default connect(mapStateToProps)(PersonalDetailsForm);
